export default "__VITE_ASSET__DmF31FBD__"